import React from 'react';

import ActionCell from 'components/Grid/components/ActionCell';
import { ColumnDefinition } from 'components/Grid/types';

import { CONTROL_FIELD } from 'containers/Controls/constants';
import { basicControlsColumns } from 'containers/Controls/components/ControlsTable/columns';
import { ControlRow } from 'containers/Controls/types';

type RowActions = {
  onOpen: (row: ControlRow) => void;
  onRemove?: (row: ControlRow) => void;
};

const PICKED_FIELDS = [
  CONTROL_FIELD.name,
  CONTROL_FIELD.category,
  'libraryStatus',
  CONTROL_FIELD.owner,
  CONTROL_FIELD.dueDate,
];

export const nameOf = (row: ControlRow): string => {
  const name = row[CONTROL_FIELD.name];
  return typeof name === 'string' ? name : '';
};

export const riskControlColumns = ({ onOpen, onRemove }: RowActions): ColumnDefinition[] => [
  ...PICKED_FIELDS.map((field) => basicControlsColumns.find((column) => column.field === field) as ColumnDefinition),
  {
    field: 'actions',
    type: 'actions',
    headerName: '',
    maxWidth: 50,
    ariaLabel: 'actions_cell',
    filterOperators: null,
    sortable: false,
    renderCell: ({ row }: { row: ControlRow }) => (
      <div data-testid={`risk-control-row-menu-${row.uuid}`}>
        <ActionCell
          recordName={nameOf(row)}
          actions={[
            { id: 'risk-control-open', label: 'Open control', onClick: () => onOpen(row) },
            {
              id: 'risk-control-remove',
              label: 'Remove from this risk',
              onClick: () => onRemove?.(row),
              visible: Boolean(onRemove),
            },
          ]}
        />
      </div>
    ),
  } as unknown as ColumnDefinition,
];
